module.exports = __webpack_public_path__ + "img/6.473caa54.png";